import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { SetFromUrl } from './../eligible-funds/+state';

@Injectable({
  providedIn: 'root',
})
export class CanActivateEligibleFundsGuard implements CanActivate {
  constructor(private store: Store) {}
  // Use can load
  // Use the below url to load the module
  //http://localhost:4200/eligible-funds?address=NjkwMCBCYXkgRHJpdmUgRSBBcHQgUEgtQiwgTWlhbWkgQmVhY2gsIEZMIDMzMTQx&state=CA&Improv_type=Windows%20%26%20Doors&max_fund=25326.36&rem_fund=22086&rem_fund_date=7%2F20%2F2020%203:33:53
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const mandateKeys = [
      'address',
      'state',
      'max_fund',
      'rem_fund',
      'rem_fund_date',
    ];
    const params = route.queryParams;
    if (mandateKeys.every((key) => Object.keys(params).includes(key))) {
      const { address, state, max_fund, improv_type, rem_fund, rem_fund_date } =
        params;

      this.store.dispatch(
        SetFromUrl({
          payload: {
            address,
            state,
            max_fund,
            rem_fund,
            improv_type,
            rem_fund_date,
          },
        })
      );
      return true;
    }
  }
}
